import TableCellSpace from "ds/components/Table/Row/CellSpace";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { ExternalIntegration } from "types/generated";

const ServiceNowTableSpaceCell = ({
  item: integration,
  ...cellProps
}: TableSimpleCellProps<ExternalIntegration>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellSpace href={`/spaces/${integration.spaceDetails.id}`}>
        {integration.spaceDetails.name}
      </TableCellSpace>
    </TableSimpleCell>
  );
};

export default ServiceNowTableSpaceCell;
